import { render, staticRenderFns } from "./tableSetup.vue?vue&type=template&id=208829de&scoped=true"
import script from "./tableSetup.vue?vue&type=script&lang=js"
export * from "./tableSetup.vue?vue&type=script&lang=js"
import style0 from "./tableSetup.vue?vue&type=style&index=0&id=208829de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208829de",
  null
  
)

export default component.exports